import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { AlertOctagon, XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Evaluaciones inconsistentes', 'Seguimientos poco claros', 'Dificultad para medir avances', 'Pérdida de tiempo constante', 'Pacientes que abandonan', 'Ingresos estancados'];
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-91">
      <div className="max-w-3xl mx-auto" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-93">
          <div className="flex items-center gap-3 mb-6" data-id="element-94">
            <AlertOctagon className="w-8 h-8 text-red-500" data-id="element-95" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-96">
              El problema que nadie te dice
            </h2>
          </div>

          <p className="text-xl text-slate-300 mb-4" data-id="element-97">
            No es que no sepas. No es que te falte experiencia.
          </p>
          <p className="text-2xl font-bold text-amber-400 mb-8 border-l-4 border-amber-500 pl-4" data-id="element-98">
            👉 Es que nunca te enseñaron a trabajar con un sistema.
          </p>
          <p className="text-lg text-slate-300 mb-8" data-id="element-99">
            Y eso, aunque no lo parezca, está afectando directamente tus
            resultados.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-100">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-3 bg-slate-950 p-4 rounded-lg border border-slate-800" data-id="element-101">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-102" />
                <span className="text-slate-200 font-medium" data-id="element-103">{problem}</span>
              </motion.div>)}
          </div>

          <div className="bg-red-950/30 border border-red-900/50 p-6 rounded-xl" data-id="element-104">
            <p className="text-lg text-slate-300 mb-2" data-id="element-105">Y lo peor…</p>
            <p className="text-xl font-bold text-white" data-id="element-106">
              👉 Esa sensación de estar trabajando mucho… pero avanzando poco.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}